import { useMutation, useQueryClient } from '@tanstack/react-query';
import { invalidateAfterItemSyncMutation } from '@/features/items/hooks/invalidateAfterItemSyncMutation';
import { ItemSyncStatusApi } from '@/features/settings/work-integrations/api/itemSyncStatus';

export const useAssignItemIntegrationMutation = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({
      itemId,
      integrationId,
      currentIntegrationId,
    }: {
      itemId: number;
      integrationId: number;
      currentIntegrationId?: number;
    }) => {
      if (currentIntegrationId === undefined) {
        return ItemSyncStatusApi.markItemAsPending({ itemId, integrationId });
      }
      return ItemSyncStatusApi.replacePendingIntegration({ itemId, integrationId });
    },
    onSuccess: (_data, { itemId }) => {
      invalidateAfterItemSyncMutation(queryClient, itemId);
    },
  });
};
